module.exports = __webpack_public_path__ + "static/media/globe_upsidedown.c05da81d.png";